import React, { ChangeEvent, FC, useState } from 'react'
import isBefore from 'date-fns/isBefore'
import endOfToday from 'date-fns/endOfToday'
import { Accordion, AccordionItem, AccordionWrapper } from 'components/Accordion'
import { Caution, SmallHeadline, SubDescription } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { DatetimePicker } from 'components/Form'
import { useToggleBoolean } from 'hooks/form'

type Props = {
  handlePreorderStartedAt: (event: ChangeEvent<HTMLInputElement>) => void
  hasScheduledPreorderStartedAt: boolean
  preorderStartedAt: string
}

const ScheduleOption: FC<Props> = (props) => {
  const { handlePreorderStartedAt, hasScheduledPreorderStartedAt, preorderStartedAt } = props
  const [isExpand, setIsExpand] = useState<boolean>(false)
  const handleExpand = useToggleBoolean(setIsExpand)
  const invalidPreorderStartedAt = isBefore(new Date(preorderStartedAt), endOfToday())
  return (
    <AccordionWrapper>
      <Accordion handleExpand={handleExpand} isExpand={isExpand} label={'オプション設定'}>
        <AccordionItem>
          <Spacer size={16} />
          <SmallHeadline label={'予約注文開始日'} />
          <Spacer size={8} />
          <SubDescription
            description={
              'お客さまが予約注文できるようになる日を設定してください。\n※アプリ上で、この日以降予約注文できるラベルが表示されます。'
            }
          />
          <Spacer size={8} />
          <DatetimePicker onChange={handlePreorderStartedAt} value={preorderStartedAt} />
          {!hasScheduledPreorderStartedAt && invalidPreorderStartedAt && (
            <Caution caution={'予約注文開始日は、本日以降に設定してください。'} />
          )}
          <Spacer size={8} />
        </AccordionItem>
      </Accordion>
    </AccordionWrapper>
  )
}

export default ScheduleOption
